import _ from 'underscore';
import {
    GET_DRIVER_PROFILE,
    UPDATE_INPUT_DRIVER_PROFILE,
    UPDATE_INPUT_CV_DRIVER_PROFILE,
    SUBMIT_DRIVER_PROFILE
} from '../actions/types';

export default function (state = {}, action) {
    switch (action.type) {
        case GET_DRIVER_PROFILE:
            return _.extend({}, state, action.payload);
        case UPDATE_INPUT_DRIVER_PROFILE:
            return _.extend({}, state, action.payload);
        case UPDATE_INPUT_CV_DRIVER_PROFILE:
            return _.extend({}, state, action.payload);
        case SUBMIT_DRIVER_PROFILE:
            return action.payload;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/app/reducers/driver_profile_reducer.js